import React, { useEffect, useState } from 'react'
import { Spinner } from '@fluentui/react'
import api from '../api-client'
import { ProjectListItem } from '../components'
import { useAppState, useInstallerMap } from '../hooks'
import { useParams } from 'react-router-dom'

import { StatusData } from '@oneethos/shared'

type ProjectPageProps = {
  lookup? : string
  isExpanded? : boolean
}

export const ProjectPage = ({ lookup, isExpanded }: ProjectPageProps) => {
  const { id } = useParams()
  const [project, setProject] = useState<Partial<StatusData>>({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  const { installersMap } = useInstallerMap()
  const { installersStatusConfig: isc, } = useAppState()
  const projectIdentifier = id || lookup

  useEffect(() => {
    api.getProject(projectIdentifier).then(item => {
      setProject(item)
    }).catch(ex => setError(ex.error || JSON.stringify(ex)))
      .finally(() => setLoading(false))
  }, [projectIdentifier])

  if (loading || isc.loading) {
    return <Spinner className="m-4" />
  }

  if (error) {
    return (
      <div className="alert alert-danger">
        <div>An error occurred while loading the project.</div>
        <div><b>Error:</b> {error}</div>
      </div>)
  }

  return (
    <ProjectListItem
      project={project as StatusData}
      installersMap={installersMap}
      onChange={p => {
        if (p instanceof StatusData) {
          setProject(p)
        } else {
          setProject(new StatusData(p))
        }
      }}
      showDetail
      isExpanded={isExpanded}
    />
  )
}

export default ProjectPage
